import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import building from '../img/building.jpg'
import Login from './LoginDos';
import Logout from './Logout';
import { CircularProgress } from '@material-ui/core';

const useStyles2 = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  center: {
    textAlign: 'center',
  },
  image: {
    backgroundImage: `url(${building})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  button: {
    margin: 10
  },
  paper: {
    margin: theme.spacing(4, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  google: {
    backgroundColor: 'green'
  },
  avatar: {
    width: 80,
    height: 80,
  },
}));

const style = {
  google: {
    width: "100%",
  }
}


export default function NewHome(props) {
  const classes2 = useStyles2();
  const { handleLogout, loading, handleOnSubmit, handleChange, form, usuarioAutenticado, handleRedirect, handleGoogleLogin, handleBack } = props;

  return (
    <Grid container component="main" className={classes2.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes2.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        {
          props.usuarioAutenticado ?
            (
              <Logout handleLogout={handleLogout} usuarioAutenticado={usuarioAutenticado} handleRedirect={handleRedirect} classes={classes2}></Logout>
            )
            :
            (
              <Login loading={loading} handleOnSubmit={handleOnSubmit} handleChange={handleChange} form={form} classes={classes2} handleGoogleLogin={handleGoogleLogin} handleBack={handleBack}></Login>
            )
        }
      </Grid>
    </Grid>
  );

}